import FlooringTableHelper from "./flooring-table-helper";
import FlooringsGridHelper from "./flooring-grid-helper";

const FlooringHelpers = {
  TableMain: FlooringTableHelper,
  GridMain: FlooringsGridHelper,
};

export default FlooringHelpers;
